module.exports = __webpack_public_path__ + "img/photo1.775087d5.jpg";